(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7388],{

/***/ 11375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FAQ; }
/* harmony export */ });
/* harmony import */ var _cleartax_wg_library_accordian__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45151);
/* harmony import */ var _cleartax_wg_library_accordian__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_cleartax_wg_library_accordian__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _shared__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25338);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24246);



var accordianClass = 'border-sm rounded-full w-6 h-6 flex items-center justify-center';
var customIconFAQ = {
  open: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
    className: accordianClass,
    children: "+"
  }),
  close: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
    className: accordianClass,
    children: "-"
  })
};
var FAQ = function FAQ(_ref) {
  var question = _ref.question,
      answer = _ref.answer;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_cleartax_wg_library_accordian__WEBPACK_IMPORTED_MODULE_0__.Accordion, {
    header: question,
    className: "border-b-sm border-grey-300 text-s-20 sm:border-x-0 sm:rounded-none sm:border-dashed sm:mt-0",
    detailPanelClasses: "overflow-x-hidden text-base pb-6 font-medium text-grey-900 justify-start sm:py-5",
    accordianHeaderEleClasses: "font-bold text-grey-900 py-6 my-0 text-s-20 sm:my-auto sm:text-base sm:font-medium",
    customIcon: customIconFAQ,
    accordionIconClasses: "text-grey-600 border-grey-600",
    onClick: function onClick() {
      (0,_shared__WEBPACK_IMPORTED_MODULE_1__/* .trackAction */ .X2)('click', question, {
        label: 'toggle_faq'
      });
    },
    children: answer
  });
};

/***/ }),

/***/ 94672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ FAQAnswer; },
/* harmony export */   "v": function() { return /* binding */ FAQSection; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var react_sanitized_html__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54150);
/* harmony import */ var _planDetailsContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38266);
/* harmony import */ var _ui_blocks_containers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6722);
/* harmony import */ var _ui_blocks_typograpghy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70015);
/* harmony import */ var _faq_index_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11375);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35812);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24246);









var FAQAnswer = function FAQAnswer(_ref) {
  var answer = _ref.answer;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().FAQ),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_sanitized_html__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      html: answer
    })
  });
};
var FAQSection = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref2, ref) {
  var id = _ref2.id,
      name = _ref2.name;
  var planDetails = (0,_planDetailsContext__WEBPACK_IMPORTED_MODULE_2__/* .usePlanCtx */ .U)();
  var FAQS = planDetails.faq;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    id: id,
    ref: ref,
    children: FAQS.length ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_ui_blocks_containers__WEBPACK_IMPORTED_MODULE_3__/* .SectionConatiner */ .I, {
      border: false,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ui_blocks_typograpghy__WEBPACK_IMPORTED_MODULE_4__/* .SectionHeading */ .O, {
        children: name
      }), FAQS.map(function (faq, idx) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_faq_index_component__WEBPACK_IMPORTED_MODULE_5__/* .FAQ */ .Z, {
          question: faq.question,
          answer: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(FAQAnswer, {
            answer: faq.answer
          })
        }, idx);
      })]
    }) : null
  });
});


/***/ }),

/***/ 6722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ SectionConatiner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);

var SectionConatiner = function SectionConatiner(_ref) {
  var children = _ref.children,
      _ref$border = _ref.border,
      border = _ref$border === void 0 ? true : _ref$border;
  var borderClass = border ? 'border-b-sm border-grey-300' : '';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
    className: "py-20 ".concat(borderClass),
    children: children
  });
};

/***/ }),

/***/ 70015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ SectionHeading; }
/* harmony export */ });
/* harmony import */ var _cleartax_wg_library_typography__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78541);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24246);


var SectionHeading = function SectionHeading(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_cleartax_wg_library_typography__WEBPACK_IMPORTED_MODULE_0__.Heading, {
    type: "h5",
    textSize: "2xl",
    weight: "bold",
    className: "text-brand-1000 ".concat(className),
    children: children
  });
};

/***/ }),

/***/ 82969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(90849);
// EXTERNAL MODULE: ../mp-library/packages/hooks/dist/index.js
var dist = __webpack_require__(95844);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./src/shared/index.ts + 5 modules
var shared = __webpack_require__(25338);
// EXTERNAL MODULE: ./src/shared/layouts/default-layout.tsx + 3 modules
var default_layout = __webpack_require__(70715);
// EXTERNAL MODULE: ./src/shared/layouts/meta.tsx
var meta = __webpack_require__(22895);
// EXTERNAL MODULE: ./src/shared/utils/tracker/configs.ts
var configs = __webpack_require__(16466);
// EXTERNAL MODULE: ./src/pages/services/[planSeoSlug]/api/index.api.ts
var index_api = __webpack_require__(91204);
// EXTERNAL MODULE: ../mp-library/packages/components/typography/dist/index.js
var typography_dist = __webpack_require__(78541);
// EXTERNAL MODULE: ./src/pages/services/[planSeoSlug]/p/planDetailsContext.tsx
var planDetailsContext = __webpack_require__(38266);
// EXTERNAL MODULE: ./src/pages/services/[planSeoSlug]/p/components/ui-blocks/containers.tsx
var containers = __webpack_require__(6722);
// EXTERNAL MODULE: ./src/pages/services/[planSeoSlug]/p/components/ui-blocks/typograpghy.tsx
var typograpghy = __webpack_require__(70015);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/page-sections/about/index.tsx







var AboutSection = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var id = _ref.id,
      name = _ref.name;
  var planDetails = (0,planDetailsContext/* usePlanCtx */.U)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: id,
    ref: ref,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* SectionConatiner */.I, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typograpghy/* SectionHeading */.O, {
        children: name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
        type: "p",
        className: "text-brand-1000 pt-6",
        weight: "medium",
        children: planDetails.longDescription
      })]
    })
  });
});
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/utils/constants.tsx
var ICONS_WHO_SHOULD_USE = ['https://assets1.cleartax-cdn.com/cleartax/images/1675230459_icon1.svg', 'https://assets1.cleartax-cdn.com/cleartax/images/1675230731_group1000001928.svg', 'https://assets1.cleartax-cdn.com/cleartax/images/1675230801_group1000002464.svg', 'https://assets1.cleartax-cdn.com/cleartax/images/1675230910_group1000002463.svg', 'https://assets1.cleartax-cdn.com/cleartax/images/1675231059_group1000002465.svg', 'https://assets1.cleartax-cdn.com/cleartax/images/1675231122_group1000002497.svg', 'https://assets1.cleartax-cdn.com/cleartax/images/1675231176_icons.svg'];
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/page-sections/documents-required/index.tsx










var DocumentsRequired = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var id = _ref.id,
      name = _ref.name;
  var planDetails = (0,planDetailsContext/* usePlanCtx */.U)();

  var _useApi = (0,dist.useApi)([], index_api/* getDocuments */.qi, true),
      getDocumentData = _useApi.request,
      documentData = _useApi.data;

  (0,react.useEffect)(function () {
    getDocumentData(planDetails.planId);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: id,
    ref: ref,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* SectionConatiner */.I, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typograpghy/* SectionHeading */.O, {
        children: name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex pt-5",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full flex flex-wrap",
          children: documentData && documentData.length ? documentData.map(function (doc, idx) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex items-center pt-6 w-1/2 pr-10 sm:w-full sm:pr-5 sm:pt-10",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: ICONS_WHO_SHOULD_USE[idx % ICONS_WHO_SHOULD_USE.length],
                alt: "document-icon",
                className: "w-12 h-12"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
                weight: "medium",
                className: "text-brand-1000 ml-4",
                children: doc.name
              })]
            }, doc.externalId);
          }) : null
        })
      })]
    })
  });
});
// EXTERNAL MODULE: ./src/pages/services/[planSeoSlug]/p/components/page-sections/faq/index.tsx
var faq = __webpack_require__(94672);
// EXTERNAL MODULE: ../node_modules/react-sanitized-html/lib/index.js
var lib = __webpack_require__(54150);
// EXTERNAL MODULE: ./src/pages/services/[planSeoSlug]/p/components/page-sections/how-its-done/process.module.css
var process_module = __webpack_require__(8890);
var process_module_default = /*#__PURE__*/__webpack_require__.n(process_module);
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/page-sections/how-its-done/index.tsx









var HowItsDone = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var id = _ref.id,
      name = _ref.name;
  var planDetails = (0,planDetailsContext/* usePlanCtx */.U)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: id,
    ref: ref,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* SectionConatiner */.I, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typograpghy/* SectionHeading */.O, {
        children: name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
        type: "p",
        className: "text-grey-600 pt-6 w-1/2 sm:w-4/5",
        weight: "medium",
        children: 'This plan is equipped with end-to-end online fulfillment via our expert. No hassle, 100% Digital.'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Heading, {
        type: "h5",
        textSize: "xl",
        weight: "bold",
        className: "text-brand-1000 pt-6",
        children: "".concat(planDetails.sla, " Days Estimate")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex pt-5",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: (process_module_default()).process,
          children: planDetails.process.map(function (service, idx) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "text-base text-brand-1000 font-semibold mb-0 pl-12",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, {
                html: service.richText
              })
            }, idx);
          })
        })
      })]
    })
  });
});

// EXTERNAL MODULE: ../mp-library/packages/components/button/dist/index.js
var button_dist = __webpack_require__(54858);
// EXTERNAL MODULE: ../node_modules/pure-react-carousel/dist/react-carousel.es.css
var react_carousel_es = __webpack_require__(53456);
// EXTERNAL MODULE: ../node_modules/pure-react-carousel/dist/index.es.js
var index_es = __webpack_require__(14088);
// EXTERNAL MODULE: ../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(73679);
// EXTERNAL MODULE: ../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(97865);
;// CONCATENATED MODULE: ./src/shared/components/ui-blocks/star-rating/starRatingContext.tsx



var _useCreateCtx = (0,dist.useCreateCtx)(),
    _useCreateCtx2 = (0,slicedToArray/* default */.Z)(_useCreateCtx, 2),
    useStarRatingCtx = _useCreateCtx2[0],
    StarRatingProvider = _useCreateCtx2[1];


;// CONCATENATED MODULE: ./src/shared/components/ui-blocks/star-rating/star.component.tsx



function Star(_ref) {
  var value = _ref.value;

  var _useStarRatingCtx = useStarRatingCtx(),
      emptyColor = _useStarRatingCtx.emptyColor,
      fillColor = _useStarRatingCtx.fillColor,
      height = _useStarRatingCtx.height,
      hover = _useStarRatingCtx.hover,
      rating = _useStarRatingCtx.rating,
      setHover = _useStarRatingCtx.setHover,
      setRating = _useStarRatingCtx.setRating,
      width = _useStarRatingCtx.width;

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "star cursor-pointer",
    onClick: function onClick() {
      return setRating(value);
    },
    onMouseEnter: function onMouseEnter() {
      return setHover(value);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(null);
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      "data-rating": value,
      fill: value <= (hover || rating) ? fillColor : emptyColor,
      height: height,
      viewBox: "0 0 25 25",
      width: width,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("polygon", {
        strokeWidth: "0",
        points: "9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78"
      })
    })
  });
}

/* harmony default export */ var star_component = (Star);
;// CONCATENATED MODULE: ./src/shared/components/ui-blocks/star-rating/starList.component.tsx





function StarsList() {
  var _useStarRatingCtx = useStarRatingCtx(),
      maxValue = _useStarRatingCtx.maxValue;

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "star-rating flex",
    children: (0,toConsumableArray/* default */.Z)(Array(maxValue)).map(function (star, index) {
      var value = index + 1;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(star_component, {
        value: value
      }, index);
    })
  });
}

/* harmony default export */ var starList_component = (StarsList);
;// CONCATENATED MODULE: ./src/shared/components/ui-blocks/star-rating/starRatingLabel.component.tsx


var StarRatingLabel = function StarRatingLabel() {
  var _useStarRatingCtx = useStarRatingCtx(),
      rating = _useStarRatingCtx.rating,
      labelText = _useStarRatingCtx.labelText;

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: labelText(rating)
  });
};
;// CONCATENATED MODULE: ./src/shared/components/ui-blocks/star-rating/starRating.component.tsx



 // export const StarRatingContext = createContext();




function StarRating(_ref) {
  var defaultState = _ref.defaultState,
      emptyColor = _ref.emptyColor,
      fillColor = _ref.fillColor,
      height = _ref.height,
      labelText = _ref.labelText,
      maxValue = _ref.maxValue,
      onChangeHover = _ref.onChangeHover,
      onChangeValue = _ref.onChangeValue,
      readOnly = _ref.readOnly,
      width = _ref.width;

  var _useState = (0,react.useState)(defaultState),
      rating = _useState[0],
      setRating = _useState[1];

  var _useState2 = (0,react.useState)(null),
      hover = _useState2[0],
      setHover = _useState2[1];

  var setRatingFn = function setRatingFn(value) {
    if (readOnly) return;
    setRating(value);
    onChangeValue(value);
  };

  var setHoverFn = function setHoverFn(value) {
    if (readOnly) return;
    setHover(value);
    onChangeHover(value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(StarRatingProvider, {
      value: {
        emptyColor: emptyColor,
        fillColor: fillColor,
        height: height,
        hover: hover,
        labelText: labelText,
        rating: rating,
        setHover: setHoverFn,
        setRating: setRatingFn,
        width: width,
        maxValue: maxValue
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StarRatingLabel, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(starList_component, {})]
      })
    })
  });
}
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/page-sections/reviews/review-carousel/index.component.tsx









var ReviewCarousel = function ReviewCarousel(_ref) {
  var reviews = _ref.reviews;
  var isMobile = (0,dist.useIsMobile)();

  var _useState = (0,react.useState)(2),
      visibleSlides = _useState[0],
      setVisibleSlides = _useState[1];

  (0,react.useEffect)(function () {
    if (isMobile) {
      setVisibleSlides(1);
    }
  }, [isMobile]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* CarouselProvider */.sj, {
    naturalSlideWidth: 100,
    isPlaying: true,
    naturalSlideHeight: 125,
    isIntrinsicHeight: true,
    infinite: true,
    visibleSlides: visibleSlides,
    totalSlides: reviews.length,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex sm:flex-col",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "z-0 w-10/12 sm:w-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* Slider */.iR, {
          className: "",
          children: reviews.length ? reviews.map(function (ele, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* Slide */.Mi, {
              index: index,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: " w-full py-3 px-2",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "px-4 shadow-lg h-60 rounded-lg bg-teal-100",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
                    className: "text-brand-1000",
                    textSize: "lg",
                    weight: "bold",
                    children: ele.reviewerName
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "flex",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(typography_dist.Text, {
                      className: "text-brand-1000",
                      textSize: "lg",
                      weight: "bold",
                      children: [ele.reviewRating, ' ']
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "mt-1 ml-1",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StarRating, {
                        defaultState: Number(ele.reviewRating),
                        emptyColor: 'grey',
                        fillColor: "#fbaa39",
                        height: 20,
                        labelText: function labelText() {
                          return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                        },
                        maxValue: 5,
                        onChangeHover: function onChangeHover() {},
                        onChangeValue: function onChangeValue() {},
                        width: 20,
                        readOnly: true
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
                    className: "text-grey-600  line-clamp-6",
                    weight: "semibold",
                    mergeClasses: "merge",
                    children: ele.reviewText
                  })]
                })
              })
            }, index);
          }) : null
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex pr-2 sm:w-full sm:mt-2 justify-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* ButtonBack */.jp, {
          className: "",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "rounded-3xl bg-grey-200 opacity-1/2  shadow-2xl p-4",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
              className: "icon-arrow-thin-right rotate-180"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* ButtonNext */.P1, {
          className: "ml-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "rounded-3xl bg-grey-200 opacity-1/2  shadow-2xl p-4",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
              className: "icon-arrow-thin-right "
            })
          })
        })]
      })]
    })
  });
};
// EXTERNAL MODULE: ../mp-library/packages/components/form/dist/index.js
var form_dist = __webpack_require__(75049);
// EXTERNAL MODULE: ../mp-library/packages/components/modal/dist/index.js
var modal_dist = __webpack_require__(25043);
// EXTERNAL MODULE: ../mp-library/packages/components/input/dist/index.js
var input_dist = __webpack_require__(38126);
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/page-sections/reviews/review-modal/reviewForm.component.tsx
/* eslint-disable max-lines */







var reviewForm_component_form = [{
  type: /*#__PURE__*/(0,jsx_runtime.jsx)(input_dist.Input, {}),
  validate: [form_dist.IsRequired],
  name: 'Your name',
  identifier: 'reviewerName',
  placeholder: 'Abhishek',
  width: 'w-ful'
}, {
  type: /*#__PURE__*/(0,jsx_runtime.jsx)(input_dist.Input, {
    isTextArea: true,
    rows: 4,
    cols: 50,
    className: "mt-1 px-3 py-2 bg-white border shadow-sm block w-full rounded-md sm:text-sm text-base focus:ring-1"
  }),
  validate: [form_dist.IsRequired],
  name: 'Your review description',
  identifier: 'reviewText',
  placeholder: '',
  width: 'w-ful'
}];
var ReviewForm = function ReviewForm(_ref) {
  var setFormValidity = _ref.setFormValidity;
  var formCtx = form_dist.useFormContext();
  (0,react.useEffect)(function () {
    setFormValidity(formCtx.isFormValid, formCtx.formState.values);
  }, [formCtx.isFormValid]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "",
      children: reviewForm_component_form.map(function (ele, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(form_dist.FormControl, {
          className: " pr-4 mb-6",
          name: ele.name,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
            type: "label",
            labelFor: ele.identifier,
            className: "text-grey-800",
            weight: "semibold",
            textSize: "sm",
            children: ele.name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(form_dist.FormField, {
            validate: ele.validate,
            name: ele.name,
            id: ele.identifier,
            children: ele.type
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(form_dist.ValidationMsg, {
            name: ele.name,
            id: ele.identifier
          })]
        }, ele.name + index);
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/page-sections/reviews/review-modal/reviewModal.component.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var ReviewModal = function ReviewModal(_ref) {
  var isOpen = _ref.isOpen,
      _onClose = _ref.onClose;

  var _useState = (0,react.useState)(false),
      formValid = _useState[0],
      setFormValid = _useState[1];

  var reviewApi = (0,dist.useApi)('', index_api/* postReview */.Zu);
  var planDetails = (0,planDetailsContext/* usePlanCtx */.U)();

  var _useState2 = (0,react.useState)(0),
      starRating = _useState2[0],
      setStarRating = _useState2[1];

  var formData = (0,react.useRef)({});

  var setFormData = function setFormData(data) {
    formData.current = _objectSpread(_objectSpread({}, formData.current), data);
  };

  var setFormValidity = function setFormValidity(isValid, value) {
    setFormValid(isValid);

    if (isValid) {
      setFormData(value);
    }
  };

  var onSubmit = function onSubmit() {
    reviewApi.request(planDetails.planId, _objectSpread(_objectSpread({}, formData.current), {}, {
      reviewRating: starRating
    }));
    (0,shared/* trackAction */.X2)('click', '', {
      label: "form_submit_review_form"
    });

    _onClose(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist.ModalContainer, {
    isOpen: isOpen,
    className: "top-1/4 p-4 rounded-lg sm:w-11/12",
    onClose: function onClose() {
      return _onClose(false);
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex justify-between",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Heading, {
        textSize: "3xl",
        className: "text-brand-1000",
        children: "Hi. Thank you for stopping by."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist.Button, {
        name: "close-review-modal",
        onClick: function onClick() {
          return _onClose(false);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
          textSize: "xl",
          weight: "bold",
          className: "text-brand-1000 icon-clear"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mt-5",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StarRating, {
        defaultState: 0,
        emptyColor: 'grey',
        fillColor: "#fbaa39",
        height: 20,
        labelText: function labelText() {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
            className: "text-brand-1000",
            children: "How do you rate our service?"
          });
        },
        maxValue: 5,
        onChangeHover: function onChangeHover() {},
        onChangeValue: function onChangeValue(value) {
          return setStarRating(value);
        },
        width: 20,
        readOnly: false
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(form_dist.FormContainer, {
      initialValues: {},
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReviewForm, {
        setFormValidity: setFormValidity
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist.Button, {
      variant: "blue",
      className: "w-full",
      disabled: !formValid || !starRating,
      onClick: function onClick() {
        return onSubmit();
      },
      children: "Submit"
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/page-sections/reviews/index.tsx













var Review = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var id = _ref.id,
      name = _ref.name;
  var planDetails = (0,planDetailsContext/* usePlanCtx */.U)();

  var _useState = (0,react.useState)(false),
      isReviewModalOpen = _useState[0],
      setIsReviewModalOpen = _useState[1];

  var reviewApi = (0,dist.useApi)([], index_api/* getReviews */.Jh, true);
  var planId = planDetails.planId;
  (0,react.useEffect)(function () {
    reviewApi.request(planId);
  }, []);

  var handleReviewButtonClick = function handleReviewButtonClick() {
    setIsReviewModalOpen(true);
    (0,shared/* trackAction */.X2)('click', '', {
      label: 'popup_open_write_review'
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: id,
    ref: ref,
    className: "relative",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* SectionConatiner */.I, {
      border: false,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typograpghy/* SectionHeading */.O, {
        children: name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
        className: "text-grey-500 mt-4",
        textSize: "sm",
        children: "Average Rating"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex mt-1",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
          textSize: "2xl",
          className: "text-brand-1000",
          weight: "bold",
          children: planDetails.rating
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
          mergeClasses: "override",
          className: "icon-star-full text-[#fbaa39] text-s-18 ml-1 mt-1"
        })]
      }), !reviewApi.isLoading && reviewApi.data ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [' ', /*#__PURE__*/(0,jsx_runtime.jsx)(ReviewCarousel, {
          reviews: reviewApi.data
        })]
      }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "sm:absolute sm:right-0 sm:top-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist.Button, {
          variant: "blue",
          className: "mt-5",
          rounded: "lg",
          onClick: function onClick() {
            return handleReviewButtonClick();
          },
          children: "Write a review"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReviewModal, {
        isOpen: isReviewModalOpen,
        onClose: function onClose() {
          return setIsReviewModalOpen(false);
        }
      })]
    })
  });
});
Review.displayName = 'Review';
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(80144);
// EXTERNAL MODULE: ./src/pages/services/[planSeoSlug]/p/components/page-sections/seo-content/index.module.css
var index_module = __webpack_require__(96070);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/page-sections/seo-content/index.tsx










var SeoContent = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var id = _ref.id,
      name = _ref.name;
  var planDetails = (0,planDetailsContext/* usePlanCtx */.U)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-testid": id,
    id: id,
    ref: ref,
    children: name && planDetails.seoContentBlock ? /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* SectionConatiner */.I, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typograpghy/* SectionHeading */.O, {
        children: name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).MainLayout,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, {
          allowedTags: [].concat((0,toConsumableArray/* default */.Z)(constants/* SANITIZE_HTML_DEFAULT_TAGS */.G4), ['img']),
          html: planDetails.seoContentBlock
        })
      })]
    }) : null
  });
});

;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/page-sections/services-included/index.tsx







var ServicesIncluded = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var id = _ref.id,
      name = _ref.name;
  var planDetails = (0,planDetailsContext/* usePlanCtx */.U)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-testid": id,
    id: id,
    ref: ref,
    children: planDetails.servicesIncluded.length ? /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* SectionConatiner */.I, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typograpghy/* SectionHeading */.O, {
        children: name
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex pt-5 sm:flex-col",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-3/5 sm:w-full",
          children: planDetails.servicesIncluded.map(function (service, idx) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex items-center pt-2",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "https://assets1.cleartax-cdn.com/cleartax/images/1675169708_group17512.svg",
                alt: "tick",
                className: "w-4 h-4"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-brand-1000 ml-4 font-medium",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, {
                  html: service.richText
                })
              })]
            }, idx);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-2/5 sm:w-full sm:pt-6 sm:flex sm:justify-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "https://assets1.cleartax-cdn.com/cleartax/images/1675231424_group10000025201.png",
            alt: "lady"
          })
        })]
      })]
    }) : null
  });
});

;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/page-sections/who-should-buy/index.tsx








var WhoShouldBuy = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var id = _ref.id,
      name = _ref.name;
  var planDetails = (0,planDetailsContext/* usePlanCtx */.U)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-testid": id,
    id: id,
    ref: ref,
    children: planDetails.whoShouldUseThis.length ? /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* SectionConatiner */.I, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typograpghy/* SectionHeading */.O, {
        children: name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex pt-5",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full flex flex-wrap",
          children: planDetails.whoShouldUseThis.map(function (service, idx) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex items-center pt-6 w-1/2 pr-10 sm:w-full sm:pr-5 sm:pt-10",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: ICONS_WHO_SHOULD_USE[idx % ICONS_WHO_SHOULD_USE.length],
                alt: "tick",
                className: "w-12 h-12"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-brand-1000 ml-4 font-medium",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, {
                  html: service.richText
                })
              })]
            }, idx);
          })
        })
      })]
    }) : null
  });
});

;// CONCATENATED MODULE: ./src/shared/components/layout-components/navigation/context.ts



var context_useCreateCtx = (0,dist.useCreateCtx)(),
    context_useCreateCtx2 = (0,slicedToArray/* default */.Z)(context_useCreateCtx, 2),
    navigationCtx = context_useCreateCtx2[0],
    NavigationProvider = context_useCreateCtx2[1];


;// CONCATENATED MODULE: ./src/shared/components/layout-components/navigation/container.tsx



var DEFAULT_ACTIVE_SECTION_ID = '';
/**
 * NavigationContainer
 *
 * @param {INavigation} props - The props for the navigation container component.
 * @param {Array<SectionProps>} props.sections - An array of sections. The type of section is ISection
 * @param {ReactNode} props.children - The children nodes to be rendered.
 *
 * @returns {JSX.Element} The navigation container component.
 *
 * https://github.com/ClearTax/mp-frontend/wiki/Navigation
 */

var NavigationContainer = function NavigationContainer(_ref) {
  var sections = _ref.sections,
      children = _ref.children;

  var _useState = (0,react.useState)(DEFAULT_ACTIVE_SECTION_ID),
      activeSectionId = _useState[0],
      setActiveSectionId = _useState[1];

  var _useState2 = (0,react.useState)(false),
      justScrolled = _useState2[0],
      setJustScrolled = _useState2[1];

  var sectionsWithData = (0,react.useRef)([]);
  /**
   * Callback function for the Intersection Observer API that detects
   * when sections of a page come into view. When a section comes into view,
   * its ID is added to an array of currently visible sections.
   * If there is at least one visible section and the user has not just scrolled,
   * the first visible section is set as the active section.
   */

  var handleObserver = function handleObserver(entries) {
    var inViewSections = entries.filter(function (entry) {
      return entry.isIntersecting;
    }).map(function (entry) {
      return entry.target.id;
    });

    if (!justScrolled && inViewSections.length) {
      setActiveSectionId(inViewSections[0]);
    }
  }; //useEffect for Setting the first section as default active


  (0,react.useEffect)(function () {
    if (sectionsWithData.current && sectionsWithData.current[0]) setActiveSectionId(sectionsWithData.current[0].props.id);
  }, []);
  /**
   * useEffect hook for IntersectionObserver.
   * Observes all sections and sets the active section when it crosses the threshold.
   */

  (0,react.useEffect)(function () {
    sectionsWithData.current = sections.filter(function (section) {
      var _section$ref$current;

      if ((_section$ref$current = section.ref.current) !== null && _section$ref$current !== void 0 && _section$ref$current.children.length && !section.props.excludeFromNav) return true;
    });
    var observer = new IntersectionObserver(handleObserver, {
      threshold: 0.5
    });
    sectionsWithData.current.forEach(function (section) {
      if (section.ref.current) observer.observe(section.ref.current);
    });
    return function () {
      observer.disconnect();
    };
  }, [justScrolled]);
  /**
   * useEffect hook to reset the `justScrolled` after 1 second.
   */

  (0,react.useEffect)(function () {
    if (justScrolled) {
      setTimeout(function () {
        setJustScrolled(false);
      }, 1000);
    }
  }, [justScrolled]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationProvider, {
    value: {
      sections: sectionsWithData.current,
      activeSection: activeSectionId,
      setJustScrolledCB: setJustScrolled,
      setActiveSectionCB: setActiveSectionId
    },
    children: children
  });
};
;// CONCATENATED MODULE: ./src/shared/components/layout-components/navigation/content.tsx


var Content = function Content(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: children
  });
};
// EXTERNAL MODULE: ./src/shared/utils/index.ts + 3 modules
var utils = __webpack_require__(47174);
;// CONCATENATED MODULE: ./src/shared/components/layout-components/navigation/utils.ts
var scrollIntoView = function scrollIntoView(element) {
  var offsetVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (!element) return;
  var offset = offsetVal;
  var bodyRect = document.body.getBoundingClientRect().top;
  var elementRect = element.getBoundingClientRect().top;
  var elementPosition = elementRect - bodyRect;
  var offsetPosition = elementPosition - offset;
  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
};
var getNameOfSection = function getNameOfSection(sections, id) {
  var foundSection = sections.find(function (section) {
    return section.props.id === id;
  });
  return foundSection ? foundSection.props.name : '';
};
var getSectionHTMLById = function getSectionHTMLById(sections, id) {
  var _foundSection$ref;

  var foundSection = sections.find(function (section) {
    return section.props.id === id;
  });
  return foundSection === null || foundSection === void 0 ? void 0 : (_foundSection$ref = foundSection.ref) === null || _foundSection$ref === void 0 ? void 0 : _foundSection$ref.current;
};
;// CONCATENATED MODULE: ./src/shared/components/layout-components/navigation/variants/vertical.tsx





var VerticalSideNav = function VerticalSideNav(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$scrollOffset = _ref.scrollOffset,
      scrollOffset = _ref$scrollOffset === void 0 ? 0 : _ref$scrollOffset;

  var _navigationCtx = navigationCtx(),
      sections = _navigationCtx.sections,
      activeSection = _navigationCtx.activeSection,
      setActiveSectionCB = _navigationCtx.setActiveSectionCB,
      setJustScrolledCB = _navigationCtx.setJustScrolledCB;

  var planContext = (0,planDetailsContext/* usePlanCtx */.U)();

  var handleClick = function handleClick(e, id, element) {
    e.preventDefault();
    setJustScrolledCB(true);
    setActiveSectionCB(id);
    scrollIntoView(element, scrollOffset);
    (0,utils/* trackAction */.X2)('click', '', {
      label: "".concat(id, "_").concat(planContext.seoSlug)
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      children: sections.map(function (section) {
        var sectionProps = section.props;
        var id = sectionProps.id,
            name = sectionProps.name;
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          onClick: function onClick(e) {
            handleClick(e, id, section.ref.current);
          },
          className: "text-s-14 cursor-pointer py-3 border-b-sm border-b-grey-300 ".concat(id === activeSection ? 'text-brand-700 underline font-bold' : 'text-grey-700 font-medium'),
          children: name
        }, id);
      })
    })
  });
};
// EXTERNAL MODULE: ../mp-library/packages/components/accordian/dist/index.js
var accordian_dist = __webpack_require__(45151);
;// CONCATENATED MODULE: ./src/shared/components/layout-components/navigation/variants/vertical-accordian.tsx







var VerticalAccordian = function VerticalAccordian(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$scrollOffset = _ref.scrollOffset,
      scrollOffset = _ref$scrollOffset === void 0 ? 0 : _ref$scrollOffset;

  var _navigationCtx = navigationCtx(),
      sections = _navigationCtx.sections,
      activeSection = _navigationCtx.activeSection,
      setActiveSectionCB = _navigationCtx.setActiveSectionCB,
      setJustScrolledCB = _navigationCtx.setJustScrolledCB;

  var planContext = (0,planDetailsContext/* usePlanCtx */.U)();

  var _useState = (0,react.useState)(false),
      dropdownOpen = _useState[0],
      setDropdownOpen = _useState[1];

  var handleClick = function handleClick(id, element) {
    setJustScrolledCB(true);
    setActiveSectionCB(id);
    scrollIntoView(element, scrollOffset);
    setDropdownOpen(false);
    (0,utils/* trackAction */.X2)('click', '', {
      label: "".concat(id, "_").concat(planContext.seoSlug)
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(accordian_dist.Accordion, {
      onClick: function onClick() {
        return setDropdownOpen(function (prev) {
          return !prev;
        });
      },
      isExpandedState: dropdownOpen,
      header: getNameOfSection(sections, activeSection),
      accordianHeaderEleClasses: 'wg-container text-s-14 h-10 text-brand-700 my-0 bg-brand-200 flex justify-start flex-shrink items-center',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "bg-white wg-container bg-brand-100",
        children: sections.map(function (section) {
          var sectionProps = section.props;
          var id = sectionProps.id,
              name = sectionProps.name;
          var isActiveSection = id === activeSection;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "text-s-14 py-2 cursor-pointer ".concat(isActiveSection ? 'text-brand-700 underline font-bold' : 'text-grey-700 font-medium'),
            onClick: function onClick() {
              handleClick(id, section.ref.current);
            },
            children: name
          }, id);
        })
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/shared/components/layout-components/navigation/index.ts





// EXTERNAL MODULE: ./src/pages/services/[planSeoSlug]/p/utils/index.tsx + 1 modules
var p_utils = __webpack_require__(7784);
// EXTERNAL MODULE: ../mp-library/packages/components/conditionals/dist/index.js
var conditionals_dist = __webpack_require__(90928);
// EXTERNAL MODULE: ../mp-library/packages/components/loader/dist/index.js
var loader_dist = __webpack_require__(66579);
// EXTERNAL MODULE: ./src/shared/utils/utils/index.tsx
var utils_utils = __webpack_require__(87353);
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/hero-fold/utils.tsx
var listingIdMap = {
  prod_itr_salary_prime_l: 'prod_itr_af_basic',
  prod_itr_salary_premium_l: 'prod_itr_af_premium',
  prod_itr_comprehensive_plan_l: 'prod_itr_af_premium',
  prod_cryptocurrency_filing_Traders_l: 'prod_itr_af_premium',
  prod_cryptocurrency_filing_Business_Premium_l: 'prod_itr_af_premium',
  prod_traders_l: 'prod_itr_af_premium',
  prod_itr_presumptive_l: 'prod_itr_af_premium',
  prod_itr_premium_l: 'prod_itr_af_black',
  prod_itr_esop_rsu_l: 'prod_itr_af_black',
  prod_itr_global_citizen_Premium_l: 'prod_itr_af_black',
  prod_itr_global_citizen_l: 'prod_itr_af_black'
};
function getNewListingId(oldListingId) {
  return listingIdMap[oldListingId] || oldListingId;
}
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/hero-fold/hero-price-card.tsx












var HeroPriceCard = function HeroPriceCard(_ref) {
  var seoSlug = _ref.seoSlug,
      planName = _ref.planName,
      symbol = _ref.symbol,
      listingId = _ref.listingId;

  var _usePlanCtx = (0,planDetailsContext/* usePlanCtx */.U)(),
      getPlanPriceDetailsApi = _usePlanCtx.getPlanPriceDetailsApi;

  var data = getPlanPriceDetailsApi.data,
      isLoading = getPlanPriceDetailsApi.isLoading,
      error = getPlanPriceDetailsApi.error;
  var discountedPrice = data.totalAmount - data.tax;
  var originalPrice = data.originalPrice;
  var discountPercentage = (0,p_utils/* getPercentageDiff */.p)(originalPrice, discountedPrice);
  var newListingId = getNewListingId(listingId);
  var checkoutUrl = "".concat(constants/* CLEARTAX_DOMAIN */.nX, "/checkout/").concat(newListingId);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "rounded-3xl bg-grey-100 h-auto mx-auto shadow-md text-center py-6 px-12 w-3/4 sm:w-full",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
      textSize: "lg",
      className: "text-brand-1000",
      weight: "bold",
      children: planName
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(loader_dist.SkeletonLoader, {
      isLoading: isLoading,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
        textSize: "4xl",
        className: "text-brand-1000 mt-4 h-10",
        weight: "bold",
        children: !isLoading && !error ? "".concat((0,utils_utils/* getCurrencyFromUnicode */._X)(symbol)).concat((0,utils_utils/* getCommaFormat */.pi)(discountedPrice)) : '$1,000'
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(loader_dist.SkeletonLoader, {
      classNames: "h-6",
      isLoading: isLoading,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex mt-2 items-center text-center justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(conditionals_dist.If, {
          condition: !!data.discountPercentage,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
            className: "text-grey-700 line-through ",
            children: !isLoading && !error ? "".concat((0,utils_utils/* getCurrencyFromUnicode */._X)(symbol)).concat((0,utils_utils/* getCommaFormat */.pi)(originalPrice)) : '$1000'
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
            weight: "extrabold",
            className: "text-red-600 pl-2 ",
            children: '(' + Math.floor(discountPercentage) + '% OFF)'
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
      type: "a",
      className: "pt-2 w-full",
      href: checkoutUrl,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist.Button, {
        onClick: function onClick() {
          (0,shared/* trackAction */.X2)('click', '', {
            label: "buy_now_product_page_".concat(seoSlug)
          });
        },
        variant: "blue",
        rounded: "lg",
        className: "w-full mt-2",
        children: "Buy now"
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/hero-fold/index.tsx









var HeroFold = function HeroFold() {
  var _usePlanCtx = (0,planDetailsContext/* usePlanCtx */.U)(),
      seoSlug = _usePlanCtx.seoSlug,
      name = _usePlanCtx.name,
      listingId = _usePlanCtx.listingId,
      amountSymbol = _usePlanCtx.amountSymbol,
      shortDescription = _usePlanCtx.shortDescription,
      rating = _usePlanCtx.rating,
      approvedReviewCount = _usePlanCtx.approvedReviewCount;

  var _navigationCtx = navigationCtx(),
      sections = _navigationCtx.sections;

  var reviewSection = getSectionHTMLById(sections, 'review'); // const planPricingDetails = getPriceDetails(listingId)

  var handleClickViewReviews = function handleClickViewReviews() {
    if (reviewSection) scrollIntoView(reviewSection);
    (0,shared/* trackAction */.X2)('click', '', {
      label: "view_reviews_".concat(seoSlug)
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex  sm:flex-col",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-1/2 sm:w-full",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Heading, {
        type: "h1",
        mergeClasses: "override",
        className: 'text-brand-1000 text-s-44 font-bold sm:text-s-24',
        children: name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
        type: "p",
        className: "text-grey-600 pt-6",
        weight: "medium",
        children: shortDescription
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex pt-6 items-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
          textSize: "xl",
          className: "text-brand-1000",
          weight: "bold",
          children: rating
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
          mergeClasses: "override",
          className: "icon-star-full text-[#FFD240] text-s-18 ml-1 mb-1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
          onClick: function onClick() {
            return handleClickViewReviews();
          },
          className: "text-grey-700 pl-4 cursor-pointer hover:underline",
          weight: "semibold",
          children: "View all reviews (".concat(approvedReviewCount, ")")
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-1/2 sm:w-full sm:pt-6",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeroPriceCard, {
        seoSlug: seoSlug,
        planName: name,
        symbol: amountSymbol,
        listingId: listingId
      })
    })]
  });
};


;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/planDetailsComponent.tsx








var PlanDetailsComponent = function PlanDetailsComponent(_ref) {
  var sections = _ref.sections;
  var herFoldRef = (0,react.useRef)(null);
  var isHeroFoldInView = (0,dist.useInView)(herFoldRef, {}, true);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationContainer, {
      sections: sections,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VerticalAccordian, {
        scrollOffset: constants/* VERTICAL_SCROLL_OFFSET */.iq,
        className: "sticky z-10 top-20 bg-white xl:hidden lg:hidden md:hidden"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "wg-container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: herFoldRef,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeroFold, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex ",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-1/4 pr-20 sm:hidden",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(VerticalSideNav, {
              scrollOffset: constants/* DESKTOP_NAV_SCROLL_OFFSET */.cg,
              className: "sticky top-20"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "w-3/4 sm:w-full",
              children: sections
            })
          })]
        })]
      }), (0,p_utils/* renderStickyBar */.F)(herFoldRef, isHeroFoldInView)]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/index.page.tsx


function index_page_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function index_page_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? index_page_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : index_page_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















var PlanPage = function PlanPage(_ref) {
  var planDetails = _ref.planDetails;
  var sections = [/*#__PURE__*/(0,jsx_runtime.jsx)(AboutSection, {
    id: 'about',
    name: 'About this plan',
    ref: (0,react.useRef)(null)
  }, 'about'), /*#__PURE__*/(0,jsx_runtime.jsx)(ServicesIncluded, {
    id: 'services-included',
    name: 'Services Included',
    ref: (0,react.useRef)(null)
  }, 'services-included'), /*#__PURE__*/(0,jsx_runtime.jsx)(WhoShouldBuy, {
    id: 'who-should-buy',
    name: 'Who Should Buy',
    ref: (0,react.useRef)(null)
  }, 'who-should-buy'), /*#__PURE__*/(0,jsx_runtime.jsx)(HowItsDone, {
    id: 'how-its-done',
    name: "How It's Done",
    ref: (0,react.useRef)(null)
  }, 'how-its-done'), /*#__PURE__*/(0,jsx_runtime.jsx)(DocumentsRequired, {
    id: 'documents-required',
    name: 'Documents Required',
    ref: (0,react.useRef)(null)
  }, 'documents-required'), /*#__PURE__*/(0,jsx_runtime.jsx)(SeoContent, {
    id: 'seo-content',
    name: planDetails.seoContentBlockTitle,
    ref: (0,react.useRef)(null)
  }, 'seo-content'), /*#__PURE__*/(0,jsx_runtime.jsx)(faq/* FAQSection */.v, {
    id: 'faq',
    name: 'FAQs',
    ref: (0,react.useRef)(null)
  }, 'faq'), /*#__PURE__*/(0,jsx_runtime.jsx)(Review, {
    id: 'review',
    name: 'Review',
    ref: (0,react.useRef)(null)
  }, 'review')];
  var seoName = planDetails.seoName,
      seoSlug = planDetails.seoSlug,
      seoDescription = planDetails.seoDescription,
      seoKeywords = planDetails.seoKeywords,
      noindex = planDetails.noindex,
      ogImage = planDetails.ogImage,
      planId = planDetails.planId;
  (0,react.useEffect)(function () {
    (0,shared/* trackAction */.X2)(configs/* EVENTS.pageView */.FP.pageView, '', {
      label: "services_".concat(seoSlug)
    });
  }, []);
  var getPlanPriceDetailsApi = (0,dist.useApi)({}, index_api/* getPriceDetails */.Ht, true);
  (0,react.useEffect)(function () {
    getPlanPriceDetailsApi.request(planId);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(default_layout/* DefaultLayout */.H, {
    meta: /*#__PURE__*/(0,jsx_runtime.jsx)(meta/* Meta */.h, {
      title: seoName,
      canonical: "/services/".concat(seoSlug, "/p"),
      description: seoDescription,
      keywords: seoKeywords,
      noindex: noindex,
      ogimage: ogImage
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(planDetailsContext/* PlanDetailsProvider */.p, {
      value: index_page_objectSpread(index_page_objectSpread({}, planDetails), {}, {
        getPlanPriceDetailsApi: getPlanPriceDetailsApi
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PlanDetailsComponent, {
        sections: sections
      })
    })
  });
};

var __N_SSP = true;
/* harmony default export */ var index_page = (PlanPage);

/***/ }),

/***/ 30391:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[planSeoSlug]/p",
      function () {
        return __webpack_require__(82969);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35812:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"FAQ":"styles_FAQ__07Vwm"};

/***/ }),

/***/ 8890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"process":"process_process__nVB4l"};

/***/ }),

/***/ 96070:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MainLayout":"seo-content_MainLayout__woQ7Z","grey-block":"seo-content_grey-block__Fr_rN","youtube-player":"seo-content_youtube-player__Hz1Cq"};

/***/ }),

/***/ 73679:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(77452);
;// CONCATENATED MODULE: ../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2279);
;// CONCATENATED MODULE: ../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7588,6308,522,3786,5207,3027,5807,9455,9774,2888,179], function() { return __webpack_exec__(30391); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);